import { render, staticRenderFns } from "./groupEventComments.vue?vue&type=template&id=b75ae730"
import script from "./groupEventComments.vue?vue&type=script&lang=js"
export * from "./groupEventComments.vue?vue&type=script&lang=js"
import style0 from "./groupEventComments.vue?vue&type=style&index=0&id=b75ae730&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports